function handleRenderCommiteeText(commitee) {
  switch (commitee) {
    case 'eu_control':
      return (
        <>
          Gönder butonuna bastığınızda madde teknik redaksiyon için
          <strong> Yayın Müdürlüğü'ne </strong>
          gönderilecektir. Onaylıyor musunuz?
        </>
      );
    case 'pub_control':
      return (
        <>
          Gönder butonuna bastığınızda madde <strong>Ansiklopedi Yayın Kurulu'na </strong>
          geçecektir. Onaylıyor musunuz?
        </>
      );
    case 'owner_committee':
      return (
        <>
          Gönder butonuna bastığınızda madde karar aşaması için <strong>Ansiklopedi Birimi'ne</strong> gönderilecektir. Onaylıyor musunuz?
        </>
      );
    default:
      return (
        <>
          Gönder butonuna bastığınızda madde <strong>Yayın Aşaması'na </strong>
          geçecektir. Onaylıyor musunuz?
        </>
      );
  }
}
const AfterCommiteeDescriptions = ({ commitee }) => {
  return (
    <div className="gx-mt-5 gx-mb-5">
      <div className="gx-text-center gx-mb-4">
        <span className="gx-mt-4 gx-mb-2">{handleRenderCommiteeText(commitee)}</span>
      </div>
    </div>
  );
};

export default AfterCommiteeDescriptions;
